export function elementIsDescendant(child: HTMLElement, parent: HTMLElement): boolean {
  let testParent:HTMLElement|null = child;
  while(testParent) {
    if(testParent === parent) {
      return true;
    }
    testParent = testParent.parentElement;
  }
  return false;
}